import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import ConfirmDialog from 'scenes/IO/components/ConfirmDialog';
import { GetIOEntityName } from 'scenes/IO/helpers';
import { signByPartnerIo } from 'scenes/IO/sources/io';

import { markAsSigned } from '../queryKeyFactory';

export const useMarkAsSignedIo = (io) => {
  const entityName = GetIOEntityName(io);
  const showModal = useScreenModalV2(ConfirmDialog);
  const markAsSignedMutation = useMutation(markAsSigned(), signByPartnerIo, {
    successMessage: () => `${entityName} marked as "Signed"`,
  });

  const handleMarkAsSigned = async () => {
    const { id } = io;

    const { attaches } = await showModal({
      title: `Mark ${entityName} as Signed by the Partner?`,
      io: io,
      confirmActionLabel: 'Mark as Signed',
      withUpload: true,
    });

    await markAsSignedMutation.mutateAsync({
      id,
      replaceAttachments: attaches,
    });
  };

  return [handleMarkAsSigned, markAsSignedMutation];
};
